import { render, staticRenderFns } from "./IfcViewer.vue?vue&type=template&id=62f64b0e&scoped=true&"
import script from "./IfcViewer.vue?vue&type=script&lang=js&"
export * from "./IfcViewer.vue?vue&type=script&lang=js&"
import style0 from "./IfcViewer.vue?vue&type=style&index=0&id=62f64b0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f64b0e",
  null
  
)

export default component.exports